module.exports = __webpack_public_path__ + "img/tablefooters.55e51355.jpg";